export default "__VITE_ASSET__DovrPR5y__"